import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Container from 'components/common/Container'
import Link from 'components/common/Link'
import Loader from 'components/common/Loader'
import FinishStage from 'components/stages/enhancement/FinishStage'
import MainLayoutContext from 'contexts/MainLayoutContext'
import useFetchRequest from 'hooks/query/useFetchRequest'
import { Rating } from 'types/Rating'
import c from './HistoryPage.module.scss'

function HistoryPage() {
  const { t } = useTranslation()

  const { requestId } = useParams()

  const { deviceId } = useContext(MainLayoutContext)

  const [rating, setRating] = useState<Rating | null>(null)

  const { data, isLoading, isSuccess, isError, error } = useFetchRequest({
    deviceId,
    requestId,
  })

  const imageUrl = data?.assets?.[0]?.source_url
  const processedImageUrl = data?.assets?.[0]?.url

  return (
    <main className={c.main}>
      <Container flex fullHeight fluid>
        {isLoading && (
          <div className={c.loader}>
            <Loader />
          </div>
        )}
        {isSuccess && imageUrl && processedImageUrl && (
          <FinishStage
            imageUrl={imageUrl}
            processedImageUrl={processedImageUrl}
            rating={rating}
            onRatingChange={setRating}
          />
        )}
        {isError && (
          <>
            <p className={c.errorMessage}>{error?.message ?? ''}</p>
            <Link className={c.errorLink} to="/">
              {t('general.buttons.backToMainPage')}
            </Link>
          </>
        )}
      </Container>
    </main>
  )
}

export default HistoryPage
